import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/article/ArticleList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/recipes/components/article/Pager.tsx");
